import {default as TagManager} from "react-gtm-module";

let gtm = TagManager;
const gtmID = import.meta.env.VITE_GTM_ID;

if (gtmID) {
  gtm.initialize({
    gtmId: import.meta.env.VITE_GTM_ID,
  });
} else {
  gtm = {
    initialize: () => {},
    dataLayer: () => null,
    // enable logging
    // dataLayer: (dataLayerArgs: DataLayerArgs) => console.log(`GTM: ${JSON.stringify(dataLayerArgs)}`),
  };
}

export default gtm;
